import React from "react";
import PropTypes from "prop-types";
import DayPicker from "react-day-picker";
import classNames from "react-day-picker/lib/src/classNames";
import _ from "lodash";
import moment from "moment";

import "./Zeitraum.css";

class Zeitraum extends React.Component {

	static propTypes = {
		range: PropTypes.shape({
			from_ms: PropTypes.number.isRequired,
			until_ms: PropTypes.number.isRequired
		}),
		max_date: PropTypes.instanceOf(Date),
		min_date: PropTypes.instanceOf(Date),
		onRangeChanged: PropTypes.func
	};
		
	constructor(props, context) {
		super(props, context);
		this.state = {
			from_ms: props.range ? props.range.from_ms : null,
			until_ms: props.range ? props.range.until_ms : null,
		};
		this.myClassNames = {
			...classNames,
			/* DayPicker verwendet "new Date()" um "Heute" zu ermitteln.
			 * Das ist nicht in unserem Sinn, weil "Heute" im Browser ein
			 * anderes Datum sein kann als "Heute" auf der Steuerung.
			 */
			today: "do_not_highlight_today",
			/* Wenn man classNames selber definiert, müssen die folgenden
			 * Eigenschaften auch explizit gesetzt werden. Es sieht so aus,
			 * als ob man diesen Mechanismus vielleicht ein wenig anders
			 * verwenden sollte ...
			 */
			outside: "DayPicker-Day--outside",		/* Standard */
			selected: "DayPicker-Day--selected",	/* Standard */
			disabled: "DayPicker-Day--disabled"		/* Standard */
		};
	}

	firstDayPickerGetMinDate() {
		let minDate = undefined;
		if(this.props.min_date) {
			minDate = this.props.min_date;
		}
		return minDate;
	}

	firstDayPickerGetMaxDate() {
		let maxDate = undefined;
		if(this.props.max_date) {
			maxDate = this.props.max_date;
			if(this.state.until_ms) {
				if(this.state.until_ms < this.props.max_date.getTime()) {
					maxDate = new Date(this.state.until_ms);
				}
			}
		}
		return maxDate;
	}

	secondDayPickerGetMinDate() {
		let minDate = undefined;
		if(this.state.from_ms) {
			minDate = new Date(this.state.from_ms)
		}
		return minDate;
	}

	secondDayPickerGetMaxDate() {
		let maxDate = undefined;
		if(this.props.max_date) {
			maxDate = this.props.max_date
		}
		return maxDate;
	}

	handleDayClick(which, day) {
		//console.log("day clicked: " + which + ": " + day);
		if ((this.state.from_ms && this.state.until_ms) &&
			((which === "from_ms" && day.getTime() > this.state.until_ms) ||
			(which === "until_ms" && day.getTime() < this.state.from_ms))) {
			/* Abbrechen, weil hier versucht wird from_ms und until_ms in
			 * ihrer Bedeutung umzudrehen. Allerdings hier nicht den ersten Klick
			 * auf eine undefinierte Zeitspanne unterdrücken.
			 */
			return;
		}
		if (this.props.max_date) {
			/*
			 * vielleicht nicht usper elegant, aber gut lesbar:
			 * wenn die selektion auf den aktuelle tag zeigt,
			 * ist sie dennoch ok!
			 */
			let mmax = moment(this.props.max_date);
			let msel = moment(this.props.max_date);
			if (!mmax.isSame(msel, 'date')
				&& this.props.max_date.getTime() < day.getTime()) {
				/* Wenn max_date definiert wurde, dann darf dort ein Klick auch keine
				* Wirkung haben.
				*/
				return;
			}
		}
		let change = !(this.state.from_ms && this.state.until_ms) ?
			{ from_ms: day.getTime(), until_ms: day.getTime() } :
			{ [which]: day.getTime() };
		this.setState(change);
		if (this.props.onRangeChanged) {
			this.props.onRangeChanged(_.merge({}, this.state, change));
		}
	}

	componentDidUpdate(prevProps) {
		// https://reactjs.org/docs/react-component.html#componentdidupdate
		// You may call setState() immediately in componentDidUpdate()
		// but note that it must be wrapped in a condition like in the example above,
		// or you’ll cause an infinite loop
		if (this.props.range !== prevProps.range) {
			this.setState({
				from_ms: this.props.range.from_ms,
				until_ms: this.props.range.until_ms,
			})
			this.props.onRangeChanged(this.props.range)
		}
	}

	render() {
		const { max_date } = this.props;
		const range = this.state.from_ms && this.state.until_ms ? {
			/* Schon mal sehr verwirrend, dass "from" und "to" anders herum sind,
				* als in der hier gebräuchlichen Logik!
				*/
			from: this.state.until_ms ? new Date(this.state.until_ms) : null,
			to: this.state.from_ms ? new Date(this.state.from_ms) : null
		} : undefined;
		return (
			<div className="almig-zeitraum">
				<DayPicker
					selectedDays={range}
					classNames={this.myClassNames}
					disabledDays={{
						before: this.firstDayPickerGetMinDate(),
						after: this.firstDayPickerGetMaxDate()
					}}
					initialMonth={
						this.state.from_ms ?
						new Date(this.state.from_ms) : max_date ?
							max_date : undefined
					}
					onDayClick={day => { this.handleDayClick("from_ms", day); }}
				/>
				<DayPicker
					selectedDays={range}
					classNames={this.myClassNames}
					disabledDays={{
						before: this.secondDayPickerGetMinDate(),
						after: this.secondDayPickerGetMaxDate()
					}}
					initialMonth={
						this.state.from_ms ?
						new Date(this.state.until_ms) : max_date ?
							max_date : undefined
					}
					onDayClick={day => { this.handleDayClick("until_ms", day); }}
				/>
			</div>
		);
	}
}

export default Zeitraum;
